import React from "react";
import CustomerNavigation from "components/CustomerNavigation";
import Head from "next/head";
import PageHeader from "components/PageHeader";
import { PageWrapper } from "components/Shared";
import AppointmentCustomerSection from "components/AppointmentCustomerSection";

export default function Appointments() {
  return (
    <CustomerNavigation>
      <Head>
        <title>GoodFriend | Appointments</title>
      </Head>
      <PageWrapper>
        <PageHeader>
          <>My appointments</>
        </PageHeader>
      </PageWrapper>
      <AppointmentCustomerSection isList />
    </CustomerNavigation>
  );
}
